export default __webpack_public_path__ + "static/media/AsiaSquare2.jpg?.a25a051a";